// hardcoded for now so needs to be adjusted every year
const config = {
  measuredValueCompareYear: 2020,
  measuredValueCurrentYear: 2022,
};

export default config;
